
import { useNavigate } from 'react-router-dom';

import { useEffect, useState } from 'react';
import { getCatSubCat, getUserDashboard } from '../../api';

import { CategoryCard, CurrentRedemPoint, goToLink, loginLogout, SpecialFiltter, useProjectByStorage, WarningDisplay } from '../../projectData';
import { useRouteData } from '../../RouteDataContext';
import { FullPageLoader } from '../../../component/helper';


/**
 * RedemptionSubCategory component
 * Displays sub-categories for a selected redemption category and allows navigation to specific sub-category pages.
 * Fetches user dashboard and category items, shows loader and warning if no items found.
 */
const RedemptionSubCategory = () => {
    const navigate = useNavigate();
    const { userData, routeData } = useRouteData();
    const [loader, setLoader] = useState(false);
    const category = routeData?.location?.state?.itemValue || {};

    const project = useProjectByStorage();
    const [dashboard, setDashboard] = useState(null);
    const [categoryitems, setCategoryItems] = useState([]);
    useEffect(() => {
        setLoader(true);
        if (userData && project) {
            getUserDashboard({ id: userData?.user?.iirpl_sap_code, project_key: project?.pkey }).then((d) => setDashboard(d?.data))
            getCatSubCat({ project_key: project?.pkey, categoryID: category?.ID }).then((d) => {
                setCategoryItems(d?.data)

                setTimeout(() => {
                    setLoader(false);
                }, 500)
            })
                .catch((error) => {
                    loginLogout(error.response)
                })
        }
    }, [userData, project])



    return (
        <div className='container pt-5 bg-white vh-100'>
            <CurrentRedemPoint dashboard={dashboard} />
            <div className="mb-4">
                <div className='text-center mt-6 fw-semibolder fs-3'>Please Select {category?.CatName} Category</div>
                <div className="row mt-6">
                    <SpecialFiltter cat_slug={category?.ID} />
                    {Array.isArray(categoryitems) && categoryitems.length > 0 ? (categoryitems.map((item, index) => (
                        <div key={item?.id} onClick={() => goToLink(navigate, `/customer/redemption-center/${item?.ID}`, { itemValue: item, dashboard: dashboard })} className="col-6 mb-4">
                            <CategoryCard item={item} />
                        </div>
                    ))) : <>{!loader && <WarningDisplay message={'Not Found'} />}</>
                    }

                </div>
            </div>
            {loader &&
                <FullPageLoader />
            }
        </div>
    )
}

export default RedemptionSubCategory